var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100"},[(_vm.$route.meta.logLayout===false)?_c('layout-default',{staticClass:"h-100"}):_vm._e(),(_vm.$route.meta.logLayout)?_c('layout-log'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }